import React from "react";

import PropTypes from "prop-types";
import "./styles.scss";

const Modal = ({ children, isVisible, onClose, title }) => {
  return (
    <div
      className={`modal-wrapper ${!isVisible && "modal-hide"}`}
      onClick={onClose}>
      <div
        className={"modal-container"}
        onClick={(e) => {
          e.stopPropagation();
        }}>
        <div className={"modal-separator"} />
        {title && <p>{title}</p>}
        <div className={"modal-separator modal-separator-full"} />
        <div className={"modal-content"}>{children}</div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default Modal;
